import React, { useEffect, useMemo, useState } from 'react';
import { FiColumns, FiX } from 'react-icons/fi';
import { modalStyles } from './styles';
import PlayerProfilePanel from './PlayerProfilePanel';

const PlayerProfileModal = ({
  playerId,
  playerName,
  onClose,
  onPreviousPlayer,
  onNextPlayer,
  playerNames = [],
  playerStats = [],
  teamId,
  selectedSeason,
  seasonDocId,
  seasonDisplayLabel,
  startDate,
  endDate,
  matchType,
  region,
  playerImage,
  playerImages = {},
}) => {
  const [isCompareMode, setIsCompareMode] = useState(false);
  const [comparePlayerName, setComparePlayerName] = useState(null);

  const compareCandidates = useMemo(
    () => (playerNames || []).filter((name) => name && name !== playerName),
    [playerNames, playerName]
  );

  useEffect(() => {
    if (!compareCandidates.length) {
      setIsCompareMode(false);
      setComparePlayerName(null);
      return;
    }

    setComparePlayerName((current) => {
      if (current && current !== playerName && compareCandidates.includes(current)) {
        return current;
      }
      return compareCandidates[0] || null;
    });
  }, [compareCandidates, playerName]);

  const comparePlayerIndex = comparePlayerName ? compareCandidates.indexOf(comparePlayerName) : -1;
  const previousComparePlayerName = comparePlayerIndex > 0
    ? compareCandidates[comparePlayerIndex - 1]
    : null;
  const nextComparePlayerName = comparePlayerIndex >= 0 && comparePlayerIndex < compareCandidates.length - 1
    ? compareCandidates[comparePlayerIndex + 1]
    : null;

  return (
    <>
      <style>{modalStyles}</style>
      <div className="player-profile-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label={`${playerName || 'Player'} profile`}>
        <div className={`player-profile-modal ${isCompareMode ? 'ppm-wide' : ''}`} onClick={(e) => e.stopPropagation()}>
          <header className="ppm-modal-topbar">
            <div>
              <h2 className="ppm-modal-title">{isCompareMode ? 'Compare Player Profiles' : 'Player Profile'}</h2>
              <p className="ppm-modal-subtitle">
                {isCompareMode ? 'Review two players side by side and browse between them.' : 'View filtered stats, match history, and lifetime info.'}
              </p>
            </div>
            <div className="ppm-modal-actions">
              <button
                type="button"
                onClick={() => setIsCompareMode((prev) => !prev)}
                className={`ppm-compare-toggle ${isCompareMode ? 'active' : ''}`}
                disabled={!compareCandidates.length}
              >
                {isCompareMode ? <FiX /> : <FiColumns />}
                {isCompareMode ? 'Exit Compare' : 'Compare'}
              </button>
              <button type="button" onClick={onClose} className="ppm-close" aria-label="Close player profile">×</button>
            </div>
          </header>

          <div className={`ppm-modal-body ${isCompareMode ? 'compare-mode' : ''}`}>
            <PlayerProfilePanel
              playerId={playerId}
              playerName={playerName}
              playerStats={playerStats}
              teamId={teamId}
              selectedSeason={selectedSeason}
              seasonDocId={seasonDocId}
              seasonDisplayLabel={seasonDisplayLabel}
              startDate={startDate}
              endDate={endDate}
              matchType={matchType}
              region={region}
              playerImage={playerImage}
              onPreviousPlayer={onPreviousPlayer}
              onNextPlayer={onNextPlayer}
            />

            {isCompareMode && comparePlayerName ? (
              <PlayerProfilePanel
                playerName={comparePlayerName}
                playerStats={playerStats}
                teamId={teamId}
                selectedSeason={selectedSeason}
                seasonDocId={seasonDocId}
                seasonDisplayLabel={seasonDisplayLabel}
                startDate={startDate}
                endDate={endDate}
                matchType={matchType}
                region={region}
                playerImage={playerImages[comparePlayerName]}
                onPreviousPlayer={previousComparePlayerName ? () => setComparePlayerName(previousComparePlayerName) : null}
                onNextPlayer={nextComparePlayerName ? () => setComparePlayerName(nextComparePlayerName) : null}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default PlayerProfileModal;
